// extracted by mini-css-extract-plugin
module.exports = {"like":"Like__like___3Oa86","count":"Like__count___3OXLG"};